


















































































/** @format */
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import { iotConfigUpdate } from '@/api/parking-lot-management/index';
export interface IForm {
  parkName: string; //车场名称
  iotEdgeAppkey: string; // APPKEY
  iotEdgeAppsecret: string; // APPSECRET
  iotEdgeAppid: string; // APPID
}
@Component({
  name: 'EditModel',
  components: { ParkingLotSearch }
})
export default class AddEditModal extends Vue {
  // 是否展示弹窗
  @Prop({ type: Boolean, default: false })
  visible!: boolean;
  // 编辑状态回填数据
  @Prop()
  data!: any;

  form: any = null;
  labelCol = { span: 6 };
  wrapperCol = { span: 15 };
  parkIds: string[] = [];
  confirmLoading: boolean = false;
  parkName: any = '';
  //form初始化
  init() {
    const { parkId, parkName, iotEdgeAppkey, iotEdgeAppid, iotEdgeAppsecret } = this.data;
    this.parkName = parkName || '';
    this.parkIds = [parkId] || [];
    this.form = this.$form.createForm(this, {
      mapPropsToFields: () => {
        return {
          parkName: this.$form.createFormField({
            value: parkName
          }),
          iotEdgeAppkey: this.$form.createFormField({
            value: iotEdgeAppkey || ''
          }),
          iotEdgeAppid: this.$form.createFormField({
            value: iotEdgeAppid || ''
          }),
          iotEdgeAppsecret: this.$form.createFormField({
            value: iotEdgeAppsecret || ''
          })
        };
      }
    });
  }
  //提交表单
  async onSubmit() {
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        this.onAddOrEdit(values);
      }
    });
  }
  //新增保存表单
  async onAddOrEdit(values: IForm) {
    if (this.confirmLoading) return;
    this.confirmLoading = true;
    try {
      const { status, msg } = await iotConfigUpdate({ ...values, parkIds: this.parkIds });
      this.successTip(status, msg);
    } catch (e) {
      this.$message.error((e && e.msg) || `编辑失败`);
    } finally {
      this.confirmLoading = false;
    }
  }
  //成功提示
  successTip(status: any, msg?: any) {
    this.confirmLoading = false;
    if (status === '9999') {
      this.$message.success(`编辑成功`);
      this.form.resetFields();
      this.$emit('create');
    } else {
      this.$message.error(msg ? msg : `编辑失败`);
    }
  }
  @Watch('visible')
  visibleChanged(val: boolean) {
    if (val) {
      this.confirmLoading = false;
      this.init();
    }
  }
}
